import React, { FC } from 'react'
import { Typography, TypographyProps, makeStyles } from 'transfix-ui/core'

const useSectionHeaderTextStyles = makeStyles({
  root: {
    fontSize: 20,
    lineHeight: 1.35,
  },
})

interface ISectionHeaderTextProps extends Pick<TypographyProps, 'children'> {}

/**
 * Header for Create Load form section
 */
export const SectionHeaderText: FC<ISectionHeaderTextProps> = ({ children }) => {
  const classes = useSectionHeaderTextStyles()
  return (
    <Typography variant='h4' classes={classes}>
      {children}
    </Typography>
  )
}
